type Cleanup = () => Promise<void>;
type Navigate = () => void;

// Start cleanup before leaving so the unmount cannot claim the same provisional camera.
export const leaveConnectionTest = (cleanup: Cleanup, navigate: Navigate): void => {
  const pendingCleanup = cleanup();
  // Navigation must not wait for the Bridge to save the camera removal.
  navigate();
  void pendingCleanup;
};
